import React, { useState, useEffect } from 'react'
import { Input } from '../UI/Input'
import { Button } from '../UI/Button'
import { ErrorAlert } from '../UI/ErrorAlert'
import { Spinner } from '../UI/Spinner'
import { Link } from 'react-router-dom'
import { APP_CONSTANTS } from '../../Common/globals'

export const LoginForm = ({ onSubmit, loading, error }) => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  })
  const [shake, setShake] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    if (error) {
      setShake(true)
      const timer = setTimeout(() => setShake(false), 500)
      return () => clearTimeout(timer)
    }
  }, [error])

  useEffect(() => {
    if (loading) {
      setShowSpinner(true)
    }
  }, [loading])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  const handleSpinnerTimeout = () => {
    setShowSpinner(false)
  }

  return (
    <div className="w-full max-w-[20rem] sm:max-w-sm relative">
      {showSpinner && (
        <div className="absolute inset-0 bg-white/80 backdrop-blur-sm z-10 flex items-center justify-center rounded-lg">
          <div className="text-center">
            <Spinner 
              size="lg" 
              color="teal" 
              withText 
              text="Signing in..." 
              timeout={2000}
              onTimeout={handleSpinnerTimeout}
            />
          </div>
        </div>
      )}
      
      <ErrorAlert message={error} />
      
      <form 
        onSubmit={handleSubmit} 
        className={`space-y-5 transition-all duration-300 ${shake ? 'animate-shake' : ''}`}
      >
        <div>
          <label htmlFor="username" className="block text-xs font-medium text-gray-700 mb-1">
            Username
          </label>
          <Input
            id="username"
            name="username"
            type="text"
            required
            value={formData.username}
            onChange={handleChange}
            placeholder="Enter your username"
            className={error ? 'border-red-300 focus:border-red-500 focus:ring-red-200' : ''}
          />
        </div>

        <div>
          <div className="flex items-center justify-between mb-1">
            <label htmlFor="password" className="block text-xs font-medium text-gray-700">
              Password
            </label>
            <Link to={APP_CONSTANTS.ROUTES.FORGOT_PASSWORD} className="text-xs text-teal-600 hover:text-teal-500">
              Forgot password?
            </Link>
          </div>
          <Input
            id="password"
            name="password"
            type="password"
            required
            value={formData.password}
            onChange={handleChange}
            placeholder="Enter your password"
            className={error ? 'border-red-300 focus:border-red-500 focus:ring-red-200' : ''}
          />
        </div>

        <div>
          <Button
            type="submit"
            loading={loading}
            disabled={loading}
            className={error ? 'bg-red-500 hover:bg-red-600' : ''}
          >
            Sign In
          </Button>
        </div>
      </form>

      <div className="text-center mt-6">
        <p className="text-gray-600 text-sm">
          Don't have an account?{" "}
          <Link to={APP_CONSTANTS.ROUTES.REGISTER} className="text-teal-600 hover:text-teal-500 font-medium">
            Sign up
          </Link>
        </p>
      </div>
    </div>
  )
}